import type { Question } from '@/types';

// Média de referência para faturamento bruto (R$50.000/mês)
const FATURAMENTO_MEDIO_REFERENCIA = 50000;
const FATURAMENTO_50PCT = FATURAMENTO_MEDIO_REFERENCIA * 0.5;

// Payback base de referência para franquias (meses)
export const PAYBACK_BASE_MONTHS = 18;

export const QUESTIONS: Question[] = [
  // ========== CREDIBILIDADE DA MARCA (40 pts) ==========
  {
    id: 'cred_segment',
    category: 'credibilidade_marca',
    text: 'Qual é o segmento do seu negócio?',
    type: 'single',
    options: [
      { value: 'alimentacao', label: 'Alimentação', score: 0 },
      { value: 'casa_construcao', label: 'Casa e Construção', score: 0 },
      { value: 'comunicacao_informatica_eletronicos', label: 'Comunicação, Informática e Eletrônicos', score: 0 },
      { value: 'entretenimento_lazer', label: 'Entretenimento e Lazer', score: 0 },
      { value: 'hotelaria_turismo', label: 'Hotelaria e Turismo', score: 0 },
      { value: 'limpeza_conservacao', label: 'Limpeza e Conservação', score: 0 },
      { value: 'moda', label: 'Moda', score: 0 },
      { value: 'saude_beleza_bem_estar', label: 'Saúde, Beleza e Bem-estar', score: 0 },
      { value: 'servicos_automotivos', label: 'Serviços Automotivos', score: 0 },
      { value: 'servicos_outros_negocios', label: 'Serviços e Outros Negócios', score: 0 },
      { value: 'servicos_educacionais', label: 'Serviços Educacionais', score: 0 }
    ],
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'cred_website',
    category: 'credibilidade_marca',
    text: 'Seu negócio possui um website profissional?',
    type: 'single',
    options: [
      { value: 'sim', label: 'Sim', score: 10 },
      { value: 'nao', label: 'Não', score: 0 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },
  {
    id: 'cred_website_url',
    category: 'credibilidade_marca',
    text: 'Ótimo! Qual é a URL do site? (ex: www.suamarca.com.br)',
    type: 'text',
    conditionalOn: { questionId: 'cred_website', expectedValue: 'sim' },
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'cred_instagram',
    category: 'credibilidade_marca',
    text: 'Sua empresa tem perfil ativo no Instagram?',
    type: 'single',
    options: [
      { value: 'sim', label: 'Sim', score: 10 },
      { value: 'nao', label: 'Não', score: 0 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },
  {
    id: 'cred_instagram_handle',
    category: 'credibilidade_marca',
    text: 'Qual é o @ do perfil no Instagram?',
    type: 'text',
    conditionalOn: { questionId: 'cred_instagram', expectedValue: 'sim' },
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'cred_marketing_agency',
    category: 'credibilidade_marca',
    text: 'Possui agência de marketing digital?',
    type: 'single',
    options: [
      { value: 'sim', label: 'Sim', score: 0 },
      { value: 'nao', label: 'Não', score: 0 }
    ],
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'cred_marketing_services',
    category: 'credibilidade_marca',
    text: 'Quais serviços a agência oferece? (Selecione todos que se aplicam)',
    type: 'multiple',
    conditionalOn: { questionId: 'cred_marketing_agency', expectedValue: 'sim' },
    options: [
      { value: 'trafego_pago', label: 'Tráfego Pago', score: 0 },
      { value: 'redes_sociais', label: 'Gestão de Redes Sociais', score: 0 },
      { value: 'seo', label: 'Criação de Artigos SEO', score: 0 },
      { value: 'assessoria_imprensa', label: 'Assessoria de Imprensa', score: 0 }
    ],
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'cred_years',
    category: 'credibilidade_marca',
    text: 'Quanto tempo de atuação no mercado a sua empresa possui?',
    type: 'single',
    options: [
      { value: 'menos_1', label: 'Menos de 1 ano', score: 0 },
      { value: '1_a_2', label: 'Entre 1 e 2 anos', score: 6 },
      { value: '2_a_5', label: 'Entre 2 e 5 anos', score: 8 },
      { value: 'mais_5', label: 'Mais de 5 anos', score: 10 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: false,
    required: true
  },
  {
    id: 'cred_units',
    category: 'credibilidade_marca',
    text: 'Seu negócio possui quantas unidades em funcionamento?',
    type: 'single',
    options: [
      { value: '1', label: '1 unidade', score: 5 },
      { value: '2', label: '2 unidades', score: 7 },
      { value: '3_ou_mais', label: '3 ou mais unidades', score: 10 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: false,
    required: true
  },

  // ========== MODELO DE NEGÓCIO E PADRONIZAÇÃO (10 pts) ==========
  {
    id: 'mod_readiness',
    category: 'modelo_negocio_padronizacao',
    text: 'Os processos da sua empresa estão documentados e prontos para replicação?',
    type: 'single',
    options: [
      { value: 'sim_completo', label: 'Sim, totalmente documentados e padronizados', score: 10 },
      { value: 'parcial', label: 'Parcialmente documentados', score: 7 },
      { value: 'nao', label: 'Não estão documentados', score: 5 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== PERFIL DO FRANQUEADOR (20 pts) ==========
  {
    id: 'perf_expansion_priority',
    category: 'perfil_franqueador',
    text: 'Qual é seu nível de prioridade para vender Franquias da sua empresa?',
    type: 'single',
    options: [
      { value: 'maximo', label: 'Máxima - Já tenho investidores', score: 10 },
      { value: 'altissima', label: 'Altíssima - Tenho muitos clientes que perguntam se é franquia', score: 9 },
      { value: 'alta', label: 'Alta - Quero encontrar investidores', score: 8 },
      { value: 'media', label: 'Média - Quero entender o potencial', score: 7 },
      { value: 'baixa', label: 'Baixa - Quero me preparar para Franquear no Futuro', score: 2 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== DIFERENCIAIS COMPETITIVOS (10 pts) ==========
  {
    id: 'dif_differentials',
    category: 'diferenciais_competitivos',
    text: 'Quais são os diferenciais que considera no seu negócio? (Selecione todos que se aplicam)',
    type: 'multiple',
    options: [
      { value: 'modelo_simples', label: 'Ter um modelo simples e fácil de operar.', score: 3 },
      { value: 'alta_lucratividade', label: 'Possuir alta lucratividade e margens consistentes.', score: 3 },
      { value: 'operacao_enxuta', label: 'Operação enxuta, com poucos funcionários.', score: 3 },
      { value: 'marketing_pronto', label: 'Soluções de marketing prontas e estrategicamente estruturadas.', score: 3 },
      { value: 'tecnologia', label: 'Tecnologia ou ferramentas que facilitam a operação.', score: 3 },
      { value: 'produto_exclusivo', label: 'Produtos exclusivos.', score: 3 },
      { value: 'pioneirismo', label: 'Pioneirismo.', score: 3 },
      { value: 'baixa_concorrencia', label: 'Baixíssima concorrência.', score: 3 },
      { value: 'outros', label: 'Outros diferenciais relevantes.', score: 3 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== CAPACIDADE DE EXPANSÃO (20 pts) ==========
  {
    id: 'exp_logistics',
    category: 'capacidade_expansao',
    text: 'Quais são os principais desafios logísticos e de fornecedores para expandir para outras cidades?',
    type: 'single',
    options: [
      { value: 'nacional', label: 'Tenho estrutura para expandir a entrega a nível Nacional', score: 10 },
      { value: 'homologar', label: 'Preciso homologar fornecedores confiáveis em outras regiões', score: 7 },
      { value: 'volume', label: 'Alguns fornecedores não suportam volumes maiores de pedidos', score: 6 },
      { value: 'custo', label: 'O custo de entrega aumenta conforme a expansão territorial', score: 6 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },
  {
    id: 'exp_other_challenges',
    category: 'capacidade_expansao',
    text: 'Outros desafios que considera relevantes?',
    type: 'single',
    options: [
      { value: 'nenhum', label: 'Não tenho nenhum desafio', score: 10 },
      { value: 'posicionamento', label: 'Preciso ajustar o posicionamento da marca antes de escalar.', score: 7 },
      { value: 'validar', label: 'Ainda preciso validar preços, margens e ticket médio de meus produtos ou serviços.', score: 8 },
      { value: 'habilidades', label: 'Meu modelo exige habilidades específicas que podem ser difíceis de ensinar.', score: 5 },
      { value: 'simplificar', label: 'Meu modelo tem potencial, mas ainda falta simplificar a operação para replicar.', score: 7 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== REGISTRO DE MARCA (10 pts) ==========
  {
    id: 'reg_inpi',
    category: 'registro_marca',
    text: 'Sua marca está registrada no INPI (Instituto Nacional da Propriedade Industrial)?',
    type: 'single',
    options: [
      { value: 'sim', label: 'Sim', score: 10 },
      { value: 'nao', label: 'Não', score: 0 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== INDICADORES FINANCEIROS (10 pts via faturamento bruto) ==========
  {
    id: 'fin_gross_revenue',
    category: 'indicadores_financeiros',
    text: 'Qual é o faturamento bruto médio mensal da sua empresa?',
    type: 'currency',
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true,
    scoringThresholds: [
      { maxValue: FATURAMENTO_50PCT - 1, score: 2 }, // < R$25k → 2 pts
      { maxValue: FATURAMENTO_MEDIO_REFERENCIA - 1, score: 6 }, // R$25k–R$50k → 6 pts
      { score: 10 }                                              // acima de R$50k → 10 pts (máx da categoria)
    ]
  },
  {
    id: 'fin_low_revenue_confirm',
    category: 'indicadores_financeiros',
    text: 'O faturamento informado é inferior a R$ 20.000,00. Você confirma esse valor ou deseja corrigir?',
    type: 'single',
    options: [
      { value: 'confirmo', label: 'Sim, confirmo o valor informado', score: 0 },
      { value: 'erro', label: 'Não, quero corrigir o valor', score: 0 }
    ],
    conditionalOn: {
      questionId: 'fin_gross_revenue',
      numericCheck: { type: 'less_than', value: 20000 }
    },
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'fin_net_revenue',
    category: 'indicadores_financeiros',
    text: 'Qual é o faturamento líquido médio mensal da sua empresa?',
    type: 'currency',
    weight: 0,
    maxScore: 0,
    required: true,
    validationRule: {
      type: 'must_be_less_than_question',
      referenceQuestionId: 'fin_gross_revenue',
      errorMessage: 'O faturamento líquido não pode ser maior que o faturamento bruto. Por favor, informe um valor menor.'
    }
  },
  {
    id: 'fin_investment',
    category: 'indicadores_financeiros',
    text: 'Se você fosse abrir hoje uma nova unidade, quanto estima que seria o investimento total necessário?',
    type: 'currency',
    weight: 0,
    maxScore: 0,
    required: true
  },


  // ========== VISÃO DO INVESTIMENTO (penúltima — perfil_franqueador) ==========
  {
    id: 'perf_investment_view',
    category: 'perfil_franqueador',
    text: 'Sabendo que a taxa média de franquia gira entre R$30 mil e R$50 mil, e que muitas vezes a venda de uma única unidade já cobre o investimento na formatação… como você enxerga esse tipo de investimento hoje?',
    type: 'single',
    options: [
      { value: 'oportunidade', label: 'Como uma oportunidade de multiplicação do negócio.', score: 10 },
      { value: 'risco_moderado', label: 'Como um risco moderado, mas que vale a pena analisar.', score: 7 },
      { value: 'risco_alto', label: 'Como um risco alto no momento.', score: 5 }
    ],
    weight: 10,
    maxScore: 10,
    improvable: true,
    required: true
  },

  // ========== PERGUNTA QUALITATIVA FINAL (sem pontuação) ==========
  {
    id: 'opt_growth_factor',
    category: 'perfil_franqueador',
    text: 'Considera algum fator que pode acelerar muito a expansão da sua marca — ou um ponto que pode dificultar esse crescimento — do qual ainda não mencionamos?',
    type: 'single',
    options: [
      { value: 'nao', label: 'Não', score: 0 },
      { value: 'sim', label: 'Sim', score: 0 }
    ],
    weight: 0,
    maxScore: 0,
    required: true
  },
  {
    id: 'opt_growth_factor_detail',
    category: 'perfil_franqueador',
    text: 'Por favor, descreva esse fator:',
    type: 'text',
    conditionalOn: { questionId: 'opt_growth_factor', expectedValue: 'sim' },
    weight: 0,
    maxScore: 0,
    required: true
  }
];

export function getQuestionById(id: string): Question | undefined {
  return QUESTIONS.find(q => q.id === id);
}

export function getQuestionsByCategory(category: string): Question[] {
  return QUESTIONS.filter(q => q.category === category);
}
